import PayrollGroupNewContributionsPage from './PayrollGroupNewContributionsPage';
export default PayrollGroupNewContributionsPage;